<template>
  <div class="flex w-full" style="position: relative">
    <admin-mission-plan
      ref="editPlan"
      :uiid="missionPlanUiid"
      :enablePayload="true"
      :enableAdvencedNav="true"
      @goto="goTo"
      @fit="fit"
    >
      <template v-slot:action>
        <v-card-actions class="pa-0 px-2 ma-0">
          <v-btn
            :disabled="!isRunnable || missionRunning == modified.MIG_ID"
            @click="runSimulationMissionGlobal()"
            small
            class="grow"
            color="primary"
          >
            {{ $t('Simulation.Run') }}
            <v-progress-circular
              class="ml-2"
              :size="20"
              v-if="missionRunning == modified.MIG_ID || !isRunnable"
              indeterminate
              color="white"
            ></v-progress-circular>
            <v-icon v-else>mdi-play</v-icon>
          </v-btn>
          <!-- <v-btn v-else :disabled="isRunnable" @click="stopSimulation()" small class="" >{{$t('Simulation.Abort')}}<v-progress-circular class="ml-2"  :size="20" v-if="missionRunning == modified.MIG_ID" indeterminate color="white"></v-progress-circular><v-icon v-else>mdi-close-octagon-outline</v-icon></v-btn> -->
          <v-autocomplete
            :items="missionPlanTemplates"
            item-text="libelle"
            item-value="id"
            :label="$t('Pilot.MissionPlan.LoadFromTemplate')"
            v-model="templateId"
            class="ml-1"
            :append-outer-icon="templateId ? 'mdi-reload' : ''"
            @click:append-outer="loadFromTemplate()"
          ></v-autocomplete>
          <v-spacer></v-spacer>
          <v-btn v-if="bestFitMisId == null" :disabled="!btnActif" @click="restoreConfig()" small class="ml-1">
            {{ $t('Pilot.MissionPlan.ReloadFromIris') }}
            <v-icon small right>mdi-replay</v-icon>
          </v-btn>
          <v-btn :disabled="!btnActif" @click="saveConfig()" small color="primary" class="ml-1">
            {{ $t('Pilot.MissionPlan.PublishStagingToIris') }}
            <v-icon small right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </template>
    </admin-mission-plan>
  </div>
</template>
<script lang="ts">
import apiAdminMissionVirtual from '@/api/admin/missionVirtual'
import {
  ISmartSimulation,
  getDefaultSmartSimulation,
  isReadyForSimulation,
} from '@/models/iris/smartMission/ISmartSimulation'
import { MissionPlanUiState, buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'
import AdminMissionPlan from '@/components/admin/missionPlanTemplate/AdminMissionPlan.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import deepEqual from 'deep-equal'
import { Watch } from 'vue-property-decorator'
import { cloneDeep } from 'lodash'
import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'
import { SimulationStatus } from '@/enum/SimulationStatus'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { Coordinate } from 'ol/coordinate'
import { Extent } from 'ol/extent'
import {
  AloDbMissionGlobalSimulation,
  isAloDbMissionGlobalCoverage,
  isAloDbMissionGlobalFormation,
  isAloDbMissionGlobalSimulation,
  isAloDbMissionGlobalSimulator,
} from '@/models/alodb/AloDbMissionGlobal'
import { CoverageStep } from '@/enum/CoverageStep'
import { CoverageState } from '@/enum/CoverageState'
import { groupByNumber, toGroupDictionnaryNumber, toNumberLookup } from '@/utils/groupBy'

@Component({
  name: 'SimulationDetailMissionPlan',
  components: { AdminMissionPlan },
})
export default class SimulationDetailMissionPlan extends Vue {
  missionRunning = -1

  saving = false

  created() {
    this.$store.myActions.MISSIONVIRTUAL_ENSURE_LIST()
    this.$store.myActions.COVERAGEITERATION_ENSURE_LIST()
    this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    this.$store.myActions.UI_ENSURE_MISSIONPLAN_STATE({ id: this.original.MIG_ID || -1, typeUiid: 'simulation' })
    this.$store.myActions.MISSIONPLANTEMPLATE_ENSURE_LIST()
    this.plan = cloneDeep(this.modified.config!.mission_plan)
  }

  get uistatebyuiid() {
    return this.$store.myGetters.uistatebyuiid
  }

  get mapState() {
    //retourne un MapUiState
    return this.uistatebyuiid(this.map_uiid) as MapUiState
  }

  get bestFitMisId() {
    return this.mapState?.bestFitMisId
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmMissionGlobal as AloDbMissionGlobalSimulation
  }

  get missionVirtualsById() {
    return this.$store.myGetters.missionVirtualsById
  }

  get endedCoverageIterations() {
    return this.$store.myGetters.coverageIterations.filter(
      ci =>
        ci.COV_PROCESSING_STEP == CoverageStep.FinalSimulation &&
        (ci.COV_PROCESSING_STATE == CoverageState.aborted || ci.COV_PROCESSING_STATE == CoverageState.finished),
    )
  }

  get maxEndedCoverageIterationIdByMigId() {
    return this.endedCoverageIterations.reduce((acc, it) => {
      if (!acc[it.MIG_ID!] || acc[it.MIG_ID!] < it.COV_ID!) acc[it.MIG_ID!] = it.COV_ID!
      return acc
    }, {} as { [key: number]: number })
  }

  get coverageIterationsById() {
    return this.$store.myGetters.coverageIterationsById
  }

  get selectedMission() {
    return this.missionVirtualsById[this.bestFitMisId]
  }

  get isRunning() {
    //TODO ameliorer avec enum
    return (
      this.selectedMission &&
      (this.selectedMission.result?.simulation_state == 'running' ||
        ((this.selectedMission.result?.simulation_state?.length ?? 0) == 0 &&
          (this.selectedMission?.VIM_STATUS ?? 0) > 0 &&
          this.selectedMission.VIM_STATUS != 10))
    )
  }

  get isRunnable() {
    //si toute les simulations ont un status différent de running
    return !this.isRunning
  }

  get original() {
    return this.$store.myGetters.originalAdmMissionGlobal as AloDbMissionGlobalSimulation
  }

  get missionPlanUiid() {
    return buildMissionPlanStateId(this.modified?.MIG_ID || -1, 'simulation')
  }

  get btnActif() {
    return !deepEqual(this.plan, this.original?.config!.mission_plan) && !this.saving
  }

  get missionPlanUiState() {
    return this.$store.myGetters.uistatebyuiid(this.missionPlanUiid) as MissionPlanUiState
  }

  get plan() {
    return this.missionPlanUiState.missionPlan
  }
  set plan(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_MISSIONPLAN({
      uiid: this.missionPlanUiid,
      plan: value,
    })
  }

  // get missionPlanTemplates() {
  //   return this.$store.myGetters.missionPlanTemplates.filter(mt => (!this.isOperator && !this.isSysAdmin)  || this.selectedFilterEnsIds == undefined || mt.ENS_ID == this.selectedFilterEnsIds)
  // }

  get missionGlobals() {
    return this.$store.myGetters.missionGlobals.filter(
      m =>
        isAloDbMissionGlobalSimulator(m) &&
        //@ts-ignore
        ((!this.isOperator && !this.isSysAdmin) ||
          this.selectedFilterEnsIds == undefined ||
          m.ENS_ID == this.selectedFilterEnsIds),
    )
  }

  get missionPlanTemplates() {
    return this.missionGlobals
      .reduce((list, m) => {
        if (isAloDbMissionGlobalCoverage(m) || isAloDbMissionGlobalFormation(m)) {
          const maxCovId = this.maxEndedCoverageIterationIdByMigId[m.MIG_ID!]
          const covIteration =
            this.coverageIterationsById[(m.config?.templateSimId ?? 0) > 0 ? m.config!.templateSimId! : maxCovId]
          if (covIteration?.resultMipJson) {
            Object.keys(covIteration.resultMipJson)?.forEach(k => {
              list.push({
                id: `${m.MIG_ID!}_${k}`,
                libelle: `${m.MIG_LIBELLE} #${k}`,
                config: covIteration.resultMipJson![k],
              })
            })
          }
        } else {
          const maxVimId = Math.max(...m.misIdArray, -1)
          list.push({
            id: m.MIG_ID!.toString(),
            libelle: m.MIG_LIBELLE,
            config:
              (m.config?.templateSimId ?? 0) > 0
                ? this.missionVirtualsById[m.config!.templateSimId!]?.param ?? m.config
                : this.missionVirtualsById[maxVimId]?.param ?? m.config,
          })
        }
        return list
      }, [] as Array<{ id: string; libelle: string | null; config: ISmartSimulation }>)
      .filter(it => (it.config?.mission_plan?.steps?.length ?? 0) > 0)
  }

  loadFromTemplate() {
    if (this.templateId) {
      //Reset le mission plan en premier lieu
      this.plan = MissionPlanUiState.getDefaultMissionPlan()
      //@ts-ignore
      if (this.$refs.editPlan) this.$refs.editPlan.reset()

      //Charge le nouveau mission plan apres
      setTimeout(() => {
        const templateConfig = this.missionPlanTemplates.find(m => m.id == this.templateId)
        if (templateConfig) {
          this.plan = cloneDeep(templateConfig.config!.mission_plan)
          //@ts-ignore
          if (this.$refs.editPlan) this.$refs.editPlan.reset()
          this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
        }
        this.templateId = null
      }, 500)
    }
  }

  get isOperator() {
    return this.$store.myGetters.isOperator
  }

  get isSysAdmin() {
    return this.$store.myGetters.isSysAdmin
  }

  get selectedFilterEnsIds() {
    //@ts-ignore
    return this.$store.myGetters.filterMission?.ensIds?.at(0) ?? undefined
  }

  templateId = null

  @Watch('modified')
  onModifiedModified() {
    if (!this.btnActif) {
      this.plan = cloneDeep(this.modified.config!.mission_plan)
    }
  }

  get map_uiid() {
    return buildSimulationUIStateId(this.original.MIG_ID!, 'map')
  }

  async saveConfig() {
    this.saving = true
    //on applique la config à l'objet car il est possible qu'un autre onglet est sauvegardé et que les modified ne concorde plus
    this.modified.config!.mission_plan = this.plan

    await this.$store.myActions.MISSIONGLOBAL_SAVE_REQUEST()
    this.plan = cloneDeep(this.modified.config!.mission_plan)
    this.saving = false
    this.$store.myActions.UI_SELECT_MISSION_MAP({ id: null, uiid: this.map_uiid })
  }

  async restoreConfig() {
    await this.$store.myActions.MISSIONGLOBAL_CANCEL_MODIFIED_ADM()
    this.plan = cloneDeep(this.modified.config!.mission_plan)
  }

  async runSimulationMissionGlobal() {
    this.missionRunning = this.modified?.MIG_ID ?? -1
    //Sauvrgarde avant le run
    try {
      this.modified.config!.mission_plan = this.plan
      await this.$store.myActions.MISSIONGLOBAL_SAVE_REQUEST()
      //@ts-ignore
      const errors = isReadyForSimulation(this.$store.myGetters.originalAdmMissionGlobal.config!)
      //console.log(errors)
      if (!errors?.length) {
        await this.$store.myActions.MISSIONGLOBAL_RUN_SIMULATION_REQUEST()
      } else {
        this.$confirm(`<ul><li>${errors.map(e => this.$t(`Simulation.Check.${e}`)).join('</li><li>')}</li></ul>`, {
          title: this.$t('Simulation.Check.Title'),
          buttonTrueText: 'Ok',
          buttonFalseText: '',
        } as VuetifyConfirmObject)
      }
    } finally {
      this.missionRunning = -1
    }
  }

  async stopSimulation() {
    this.missionRunning = this.modified?.MIG_ID ?? -1
    try {
      //await this.$store.myActions.MISSIONGLOBAL_ABORT_SIMULATION_REQUEST();
      await apiAdminMissionVirtual.updateStatus(this.bestFitMisId!, SimulationStatus.aborted)
      this.selectedMission.VIM_STATUS = SimulationStatus.aborted
    } finally {
      this.missionRunning = -1
    }
  }

  goTo(coordinate: Coordinate) {
    //console.log("coordinate",coordinate)
    this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
  }

  fit(extent: Extent) {
    //console.log("extent",extent)
    this.$store.myActions.UI_REFRESH_BEST_FIT_MAP(this.map_uiid)
  }
}
</script>
